<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <!-- 页面头部区域 -->
        <div class='main-page-header'>
          <el-button
            type='default'
            icon='el-icon-arrow-left'
            @click='handleBack'
          >
            返回
          </el-button>
          <h2 class='cursor-pointer' @click='getTplInfo'> {{ '刊例设置' }}</h2>
        </div>

        <div class='flex-container'>
          <div style='margin: 10px'>
            <el-input v-model='formData.title' style='width: 500px;font-size: 20px' placeholder='工作簿名称' clearable>
              <template slot='append'>
                <el-button class='el-icon-edit-outline'></el-button>
              </template>
            </el-input>

          </div>

          <div class='w-full'>
            <el-form :model='formData' label-position='right' label-suffix='：' inline>
              <div style='display: flex; flex-direction: column; justify-content: flex-start;gap: 2px'>
                <el-card class='panel w-full'>
                  <div slot='header'>
                    <span class='font-bold'>平台Logo配置</span>
                  </div>
                  <div class='text-center'>
                    <!--                    <div class='title-tag'>平台Logo配置</div>-->
                    <div
                      class='theme-border text-left p-10'
                      style='display: flex; flex-direction: column; justify-content: flex-start;align-items: flex-start'>
                      <el-form-item label='Logo图标'>
                        <div class='flex-column'>
                          <div class='theme-border p-10'>
                            <img :src='formData.work_sheet.logoSetting.logo_url' alt='刊例Logo图'
                                 :style='`width: ${formData.work_sheet.logoSetting.width}px;height:${formData.work_sheet.logoSetting.height}px`'>
                          </div>
                          <el-link type='primary' icon='el-icon-edit' @click='dialogLogoVisible=true'></el-link>
                        </div>
                      </el-form-item>
                      <el-form-item label=' Logo单元格'>
                        位于 第
                        <el-input placeholder='Logo图标摆放列，例如：E' v-model='formData.work_sheet.logoSetting.cellCol'
                                  clearable
                                  style='width: 80px' />
                        列，
                        第
                        <el-input placeholder='Logo图标摆放行，例如：1' v-model='formData.work_sheet.logoSetting.cellRow'
                                  clearable
                                  style='width: 80px' />
                        行
                      </el-form-item>
                      <el-form-item label='偏移量'>
                        X轴偏移
                        <el-input placeholder='X轴偏移量' v-model='formData.work_sheet.logoSetting.offsetX' clearable
                                  style='width: 80px' />
                        磅，
                        Y轴偏移
                        <el-input placeholder='Y轴偏移量' v-model='formData.work_sheet.logoSetting.offsetY' clearable
                                  style='width: 80px' />
                        磅
                      </el-form-item>
                      <el-form-item label='尺寸'>
                        宽度
                        <el-input placeholder='宽度' v-model='formData.work_sheet.logoSetting.width' clearable
                                  style='width: 80px' />
                        磅，
                        高度
                        <el-input placeholder='高度' v-model='formData.work_sheet.logoSetting.height' clearable
                                  style='width: 80px' />
                        磅
                      </el-form-item>
                    </div>
                  </div>
                </el-card>
                <el-card class='panel w-full'>
                  <div slot='header'>
                    <span class='font-bold'>表头设置</span>
                  </div>
                  <div>
                    <el-form-item label='背景色值'>
                      <div> {{ formData.bg_color || '--' }}</div>
                      <el-color-picker
                        v-model='formData.bg_color'
                        show-alpha
                        :predefine='predefineColors'>

                      </el-color-picker>
                    </el-form-item>
                    <el-form-item label='字颜色值'>
                      <div>{{ formData.font_color }}</div>
                      <el-color-picker
                        v-model='formData.font_color'
                        show-alpha
                        :predefine='predefineColors'>
                      </el-color-picker>
                    </el-form-item>
                    <el-form-item label='行高'>
                      <el-input type='text' :placeholder='`表格行高(单位默认：pt(points 磅值),推荐：${header_height}`'
                                v-model='formData.header_height' style='width: 200px' clearable />
                      &nbsp;
                      &nbsp;
                      <el-link @click='setHeaderHeight'>推荐行高：{{ header_height }}</el-link>
                      <p style='font-size: 0.8em;'>
                        Valid units are pt (points 磅值), px (pixels), pc (pica), in (inches), cm (centimeters) and mm
                        (millimeters).
                      </p>
                    </el-form-item>
                  </div>
                </el-card>
                <el-card class='panel'>
                  <div slot='header'>
                    <span class='font-bold'>刊例类型（{{ formData.type }}）</span>
                  </div>
                  <div>
                    <el-row>
                      <el-col :span='24'>
                        <el-radio-group v-model='formData.type'>
                          <el-radio :label='item.val' :value='item.val' v-for='(item,index) in typeMap' :key='index'>
                            {{ item.title }}<span>刊例</span>
                          </el-radio>
                        </el-radio-group>
                      </el-col>
                    </el-row>
                  </div>
                </el-card>
              </div>
            </el-form>
          </div>

          <el-card class='panel'>
            <div slot='header' class='flex-sb'>
              <span>第一部分-常规字段({{ formData.common_fields.length }}/{{ common_cols.length }})</span>
              <div>
                <el-link type='warning' @click='handleClear("common_fields")'>重置</el-link>
              </div>

            </div>
            <div>
              <el-checkbox-group v-model='formData.common_fields'>
                <el-checkbox @change='forceUpdate(extra_col)' :label='extra_col.field'
                             :value='extra_col.field'
                             v-for='(extra_col,index) in common_cols' :key='index'>
                  <span :title='extra_col.placeholder'>{{ index + 1 }}、{{ extra_col.title }}</span>
                  <span v-if='extra_col.is_default' title='默认项'>(<i class='el-icon-check'></i>)</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-card>

          <!--          报价配置-->
          <div class='border-effect w-full mt-10'>
            <PlcQuoteSetting :show-edit-btn='false' :form-data.sync='formData' @handleSave='handleSaveQuote'
                             class='w-full' />
          </div>

          <!--          导出表格配置-->
          <div class='border-effect p-10'>
            <!--            formData.platform_quote-->
            <PlcColumnsTable ref='refSheetSetting'
                             :form-data.sync='formData'
                             @handleSave='handleSaveSheetSetting'></PlcColumnsTable>
          </div>

          <!--          <div style='width: 98%;text-align: center;padding: 10px' class='theme-border'>-->
          <!--            <el-button type='primary' @click='handleSave' style='width: 160px' size='medium' round>保存配置</el-button>-->
          <!--          </div>-->
        </div>

        <div class='show-json-btn theme-border' style='display: none'>
          <el-link @click='showSettingJson=!showSettingJson' icon='el-icon-view'></el-link>
        </div>
        <div v-if='showSettingJson'>
          <JsonDisplay
            v-model='formData'
            title='配置内容'
            :showHighlight='false'
            :rows='4'
            :show-char-count='true'
          />

        </div>
      </div>
    </PageHeaderLayout>

    <!--    视频报价配置-->
    <el-dialog :visible.sync='dialogPriceVisible' width='600px'>
      <div class='form-card'>
        <el-form :inline='false' :model='formQuote' label-width='90px' label-position='right'>
          <el-form-item label='报价标题'>
            <el-input type='textarea' rows='2' v-model='formQuote.title' clearable></el-input>
          </el-form-item>
          <el-form-item label='报价字段'>
            <el-input v-model='formQuote.field' clearable>
              <span slot='prepend'>quote_</span>
            </el-input>
          </el-form-item>
          <el-form-item label='数据类型'>
            <el-select v-model='formQuote.type' class='w-full'>
              <el-option value='number' label='数值'></el-option>
              <el-option value='text' label='文本'></el-option>
              <el-option value='textarea' label='文本域'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='描述'>
            <el-input type='textarea' v-model='formQuote.placeholder' placeholder='描述该字段用途或者举例'
                      clearable></el-input>
          </el-form-item>
        </el-form>
        <div>
          <el-button @click='addRow' type='primary' v-if='currentIndex===-1'>添加</el-button>
          <el-button @click='saveRow' type='primary' v-else>保存</el-button>
          <el-button @click='resetRow' type='info'>重置</el-button>
        </div>
      </div>
    </el-dialog>


    <PlcFieldDialog :visible.sync='dialogVisible'></PlcFieldDialog>

    <el-dialog :visible.sync='dialogLogoVisible'>
      <ape-uploader @handleUploadSuccess='handleUploadSuccess'
                    :uploadFileList='uploadFileList' :allowSize='allowSize' />
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import EditableCell from '@/components/EditableCell'
import PlcFieldDialog from '@/pages/platform/components/PlcFieldDialog'
import PlcColumnsTable from '@/pages/plc/setting/PlcColumnsTable'
import plcMap from '@/json/plc.json'
import ApeUploader from '@/components/ApeUploader'
import PlcQuoteSetting from '@/pages/plc/setting/PlcQuoteSetting'
import JsonDisplay from '@/components/display/JsonDisplay.vue'
import { savePlcTpl, getPlcTpl } from '@/api/plc'

const { deepClone } = require('@/utils')
//视频时长报价-表单数据结构
const singlePriceStruct = { title: '', field: '', placeholder: '请输入信息', type: 'text', val: '' }

export default {
  name: 'PlcTpl',
  components: {
    JsonDisplay,
    PlcQuoteSetting,
    ApeUploader,
    PageHeaderLayout, EditableCell, PlcFieldDialog, PlcColumnsTable
  },
  computed: {
    quoteMulti() {
      return this.quoteInfo.multi[this.formData.type] || []
    },
    quoteMixed() {
      return this.quoteInfo.mixed || {}
    },
    priceShowMap() {
      if (this.formData.type && this.customPriceMap) {
        return this.customPriceMap[this.formData.type] || {
          'multi': true,
          'single': true,
          'mixed': true,
          'showLast': true
        }
      } else
        return {
          'multi': true,
          'single': true,
          'mixed': true,
          'showLast': true
        }
    },
    uploadFileList() {

      return [{ url: this.formData.work_sheet.logoSetting.logo_url }]
    }
  },

  data() {
    return {
      platform_id: null,
      // uploadFileList: [],
      allowSize: 1024 * 1024 * 10,
      platform: { name: '', code: '' },
      loading: false,
      showSettingJson: false,
      activeName: 'checkbox',
      activePriceName: 'single',
      header_height: '31.5pt',//表格行高
      // 配置的表单
      formData: {
        id: null,
        title: '',
        type: 'ONLINE',
        bg_color: '#000000',
        font_color: '#FFFFFF',
        header_height: '31.5pt',//表格行高
        //全部配置
        common_fields: [],//常规字段
        platform_quote: [],//平台报价字段
        extra_fields: [],//其他字段
        columns_data: [],//列自定义数据
        work_sheet: {
          logoSetting: {
            cellCol: 'E',
            cellRow: 1,
            width: 50,
            height: 50,
            offsetX: 10,
            offsetY: 10
          }
        }
      },
      setting: {
        quote: {
          price_type_map: this.priceTypeMap,
          setting: { multi: this.quoteMulti, single: [], mixed: this.quoteMixed }
        },
        common_fields: [],//常规字段
        platform_quote: [],//平台报价字段
        extra_fields: [],//其他字段
        columns_data: []//列自定义数据
      },
      typeMap: plcMap.typeMap,
      common_cols: plcMap.common_cols,
      extra_cols: [],
      multiChecked: false,
      singleChecked: false,
      priceTypeMap: {
        'multi': {
          'title': '品类场次报价',
          'checked': true
        },
        'single': {
          'title': '报价类目报价',
          'checked': true
        },
        'mixed': {
          'title': '专（混）场报价',
          'checked': true
        }
      },
      customPriceMap: plcMap.customPriceMap,
      quoteInfo: plcMap.quoteInfo,
      extra_fields: [],
      dateTypeMap: [
        { label: '数值', value: 'number' }
        , { label: '文本', value: 'text' }
        , { label: '文本域名', value: 'textarea' }
        // , { label: '富文本', value: 'richtext' }
      ],
      formQuote: singlePriceStruct,
      currentIndex: -1,
      quoteMap: {},
      predefineColors: [
        'rgba(0,0,0,1)',
        'rgba(255,0,59,1)',
        'rgba(255,182,0,1)',
        'rgba(0,158,239,1)',
        'rgba(255,78,0,1)',
        'rgba(179,0,0,1)',
        'rgba(255,255,250,1)',
        'rgba(255,255,200,1)'
      ],
      columns: [],//表格列表配置
      //excel表格配置
      excelDataList: [],
      dialogVisible: false,
      dialogLogoVisible: false,
      dialogPriceVisible: false
    }
  },
  methods: {
    handleBack() {
      this.$confirm('确定要返回吗？未保存的内容将会丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => {
        // 用户取消操作
      })
    },
    insertColumn(item, rangeArr) {
      const index = this.formData.columns_data ? this.formData.columns_data.findIndex(value => value.field === item.field) : -1

      // let rowOrg = this.formData.columns_data[index];
      const row = {
        field: item.field,
        title: item.title,
        height: '80.1',
        width: '15',
        horizontal: 'center',
        showTool: true,
        children: item.children
      }
      // Object.assign(row, rowOrg)//合并数据
      if (rangeArr.indexOf(item.field) > -1 && index === -1)
        this.formData.columns_data.push(row)
    },
    calcColumns() {
      this.common_cols.forEach((item) => {
        this.insertColumn(item, this.formData.common_fields)
      })
      //报价字段
      this.formData.platform_quote.forEach((item) => {

        this.insertColumn(item, [item.field])
      })
      //额外字段
      this.extra_cols.forEach((item) => {
        this.insertColumn(item, this.formData.extra_fields)
      })
    },

    // eslint-disable-next-line no-unused-vars
    handleCellEnter(row, column, event) {
// 鼠标悬浮单元格时的处理逻辑
      // console.log(`鼠标悬浮在: ${row[column.property]} - ${column.label}`)
    },
    // eslint-disable-next-line no-unused-vars
    handleCellLeave(row, column, event) {
      // 鼠标离开单元格时的处理逻辑
      // console.log(`鼠标离开: ${row[column.property]} - ${column.label}`)
    },
    // eslint-disable-next-line no-unused-vars
    handleRowDbClickEvent(row, column, event) {
      const index = this.formData.platform_quote.indexOf(row)
      this.editRow(row, index)
    },
    // eslint-disable-next-line no-unused-vars
    editRow(row, index) {
      this.dialogPriceVisible = true
      this.formQuote = deepClone(row)
      this.currentIndex = index
      // this.calcColumns()
    },

    saveRow() {
      this.formData.platform_quote[this.currentIndex] = {}
      this.formData.platform_quote[this.currentIndex] = { ...this.formQuote }

      this.resetRow()

    },
    addRow() {
      // 报价列字段必须quote_开头
      if (this.formQuote.field.indexOf('quote_') !== 0) {
        this.formQuote.field = 'quote_' + this.formQuote.field
      }

      this.formData.platform_quote.push({ ...this.formQuote })

      this.saveSetting('platform_quote')
      this.dialogPriceVisible = false
    },
    resetRow() {
      this.currentIndex = -1
      this.formQuote = { ...singlePriceStruct }

    },
    //复选框勾选后触发
    forceUpdate() {
      // this.calcColumns()//重新计算表格列
      this.$forceUpdate()
    },
    //保存配置
    async handleSave() {
      const setting = {
        quote: {
          type_map: this.priceTypeMap,
          setting: { multi: this.quoteMulti, single: this.formData.platform_quote, mixed: this.quoteInfo.mixed }
        },
        common_fields: this.formData.common_fields,
        platform_quote: this.formData.platform_quote,
        // extra_fields: this.formData.extra_fields,
        columns_data: this.formData.columns_data,
        work_sheet: { logoSetting: this.formData.work_sheet.logoSetting },
        type: this.formData.type,
        title: this.formData.title,
        bg_color: this.formData.bg_color || '#000000',
        font_color: this.formData.font_color,
        header_height: this.formData.header_height
      }
      this.loading = true
      await savePlcTpl(this.id, setting)
      this.loading = false
      this.$notify.success('已保存！！')
    },
    //清空
    handleClear(field) {
      this.formData[field] = []
    },
    async saveSetting() {
      await this.handleSave()
    },

    reset() {
      this.resetRow()
    },
    setHeaderHeight() {
      this.formData.header_height = this.header_height
    },

    handleAddToExcelCol(item) {
      let itemChildren = []
      if (item.field === 'multi') {
        // 计算 children
        itemChildren = this.getMultiChildren()
      }
      const cell = {
        field: item.field,
        title: item.title,
        height: '80.1',
        width: '15',
        horizontal: 'center',
        merge_col: 'Y',
        merge_row: 'Y',
        showTool: true,
        children: itemChildren
      }
      this.formData.columns_data.push(cell)
    },
    getMultiChildren() {
      // 平台报价字段(multi)
      return this.quoteMulti.cols
    },
    //保存导出表格【工作簿配置】
    handleSaveSheetSetting(data) {
      this.formData.columns_data = data
      // console.log('d', data)
      this.saveSetting('columns_data')
    },
    handleUploadSuccess(data) {
      this.formData.work_sheet.logoSetting.logo_url = data.full_path
    },
    handleSaveQuote() {
      this.saveSetting('platform_quote')
    },
    async getTplInfo() {
      const info = await getPlcTpl(this.id)

      const setting = info.setting

      delete info.setting
      // 刊例表格-表头设置、刊例类型：formData.type、第一部分-常规字段：formData.common_fields
      this.formData = { ...info, ...setting }
      // Logo设置
      if (this.formData.work_sheet.logo)
        this.formData.work_sheet.logoSetting = this.formData.work_sheet.logo

      this.$nextTick(() => {
        this.$refs['refSheetSetting'].showSourceTable()
      })
    }
  },
  created() {
    this.id = this.$route.params ? this.$route.params.id : null
    if (this.id) {
      this.getTplInfo()
    }

  }
}
</script>

<style scoped>
.title-tag {
  display: inline-block;
  border: 1px solid #f2f2f2;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 20px;
  //background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px 0 rgba(31, 38, 135, 0.2);
  //background-color: var(--primary);
  background: linear-gradient(45deg, var(--primary), #764ba2);
  color: #F2F2F2;
  //background: linear-gradient(to bottom right,var(--primary), #764ba2);
  //background: linear-gradient(to bottom right, #667eea, #764ba2);
  //background: linear-gradient(to right, var(--primary), #764ba2);
}

.edit-view {
  width: clamp(400px, 90vw, 1280px);
  border-radius: 10px;
  padding: 20px
}

.panel {
  margin-top: 10px;
}

.form-card {
  border: #DCDFE6 1px solid;
  border-radius: 10px;
  padding: 10px 10px;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 10px;
}

.flex-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: auto;
  border: #f2f2f2 1px solid;
  padding: 10px;
}

.left {
  width: clamp(400px, 90vw, 1280px);
}

.show-json-btn{

  z-index: 999;
  opacity: 0.7;
}
</style>
<style>
.click-row-over {
  /*color: #fe346e !important;*/
  cursor: pointer;
  background-color: rgb(117, 43, 236);
}
</style>
